import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, Output } from "@angular/core";
import { AbstractControl, FormControl, FormGroup, ReactiveFormsModule, ValidatorFn, Validators } from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";
import { PopupPasswordTemplateComponent } from "@shared/components/popup-password-template/popup-password-template.component";
import { PASSWORD_REQUIREMENTS } from "@shared/constants/validators.constants";
import { Member } from "@shared/models/member";
import { UpdateMember } from "@shared/models/update-member";
import { MembersService } from "@shared/services/members.service";
import { ButtonModule } from "primeng/button";
import { OverlayPanelModule } from "primeng/overlaypanel";
import { TooltipModule } from "primeng/tooltip";

@Component({
  selector: "app-change-password",
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    OverlayPanelModule,
    ButtonModule,
    TranslateModule,
    TooltipModule,
    PopupPasswordTemplateComponent,
  ],
  templateUrl: "./change-password.component.html",
  styleUrls: ["./change-password.component.scss"],
})
export class ChangePasswordComponent {
  passwordForm: FormGroup;
  errorMessage = "";
  apiErrorMessage = "";
  submittionSuccess = false;
  @Input() member: Member | undefined;
  @Output() changePasswordToggle = new EventEmitter<boolean>();
  showOldPassword = false;
  showNewPassword = false;
  showConfirmPassword = false;

  passwordMatchValidator(): ValidatorFn {
    return (control: AbstractControl): Record<string, any> | null => {
      const newPassword = control.get("newPassword")?.value;
      const confirmPassword = control.get("confirmPassword")?.value;
      return newPassword === confirmPassword ? null : { passwordMismatch: true };
    };
  }

  constructor(private membersService: MembersService) {
    this.passwordForm = new FormGroup(
      {
        oldPassword: new FormControl("", Validators.required),
        newPassword: new FormControl("", [
          Validators.required,
          Validators.minLength(8),
          Validators.pattern(PASSWORD_REQUIREMENTS),
        ]),
        confirmPassword: new FormControl("", [
          Validators.required,
          Validators.minLength(8),
          Validators.pattern(PASSWORD_REQUIREMENTS),
        ]),
      },
      { validators: this.passwordMatchValidator() }
    );
  }

  onSubmit() {
    if (this.passwordForm.valid) {
      const command: UpdateMember = {
        id: this.member?.id ?? "",
        oldPassword: this.passwordForm.get("oldPassword")?.value,
        newPassword: this.passwordForm.get("newPassword")?.value,
      };
      this.membersService.updateMemberContact(command).subscribe({
        next: () => {
          this.errorMessage = "";
          this.apiErrorMessage = "";
          this.passwordForm.reset();
          this.changePasswordToggle.emit(true);
          this.submittionSuccess = true;
        },
        error: error => {
          if (error.error.detail) {
            this.apiErrorMessage = error.error.detail;
          } else {
            this.errorMessage = "Erreur lors du changement de mot de passe.";
          }
        },
      });
    }
  }

  onCancel() {
    this.passwordForm.reset();
    this.errorMessage = "";
    this.apiErrorMessage = "";
    this.changePasswordToggle.emit(false);
  }
}
